import { render, staticRenderFns } from "./edit-signature.vue?vue&type=template&id=813924ac&"
import script from "./edit-signature.vue?vue&type=script&lang=js&"
export * from "./edit-signature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports